/// <reference path="../../../../typings/index.d.ts" />
module App.Common.Directives {
	'use strict';

	export class AddressFinderDirective implements angular.IDirective {

		public addressFinderDirective() { }

		public restrict = 'E';

		public controller = Common.Controllers.AddressFinderController;

		public controllerAs = 'ap';

		public bindToController = true;

		public transclude = false;

		public template: string;

        public scope = { ngModel: '=', header: '@' } as { [boundProperty: string]: string };

		public require = ['ngModel'];

        public templateUrl = 'Templates/Common/AddressFinderView.html';

	}
    
	angular
		.module('app.common.directives')
		.directive('addressfinder', () => { return new AddressFinderDirective(); });
}